import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Container, Button, Box, Grid, Typography, InputBase, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Link } from '@material-ui/core';
import HandImg from '../../assets/hand.png';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GetAllFAQS } from '../../actions/homeActions';
import { Link as RouterLink } from 'react-router-dom';

const styles = theme => ({
    donateBox: {
        marginTop: 40
    },
    handContent: {
        background: '#FEC553',
        padding: '10px 15px',
        textAlign: 'center',
        borderRadius: '4px 4px 0px 0px',
        marginTop: 40
    },
    handContent2: {
        background: '#00C9A8',
        padding: '10px 15px',
        textAlign: 'center',
        borderRadius: '4px 4px 0px 0px',
        marginTop: 40
    },
    donateContent: {
        border: '2px solid #FEC553',
        background: '#fff',
        padding: '15px 15px 20px',
        borderRadius: '0px 0px 4px 4px'
    },
    donateContent2: {
        border: '2px solid #00C9A8',
        background: '#fff',
        padding: '15px 15px 20px',
        borderRadius: '0px 0px 4px 4px'
    },
    donateTitle: {
        color: '#080F58',
        fontFamily: 'Roboto Slab',
        fontSize: 24,
        margin: 0
    },
    donateButton: {
        padding: 10,
        background: '#FEC553',
        borderRadius: 3,
        color: 'white',
        border: 0,
        width: '100%',
        marginBottom: 10,
        '&:hover': {
            background: '#FEC553'
        }
    },
    donateButton2: {
        padding: 10,
        background: '#00C9A8',
        borderRadius: 3,
        color: 'white',
        border: 0,
        width: '100%',
        marginBottom: 10
    },
    donate: {
        color: '#666',
        fontSize: 14,
        fontFamily: 'Open Sans',
        lineHeight: 1.5
    },
    iconColor: {
        background: '#fff',
        color: '#080F58',
        cursor: 'pointer'
    },
    root: {
        width: '100%',
    },
    question: {
        color: '#00000099',
        fontFamily: 'Roboto Slab',
        fontSize: 24,
        cursor: 'pointer',
        lineHeight: 1.5
    },
    activeColor: {
        color: '#080F58',
    },
    answer: {
        color: '#666',
        fontSize: 16,
        lineHeight: '34px',
        paddingRight: 60,
        '@media (max-width:600px)': {
            paddingRight: 0
        }
    },
    searchBox: {
        marginBottom: 35
    },
    searchButton: {
        width: '100%',
        height: 70,
        background: '#00C9A8',
        color: '#fff',
        border: 'none',
        fontSize: '20px',
        borderRadius: '0px 4px 4px 0px',
        textTransform: 'uppercase',
        fontWeight: 500,
        fontFamily: 'Roboto',
        '&:hover': {
            background: '#00C9A8'
        }
    },
    searchField: {
        width: '100%',
        background: '#f7f7f7',
        height: 70,
        fontSize: '20px',
        border: 0,
        borderRadius: '4px 0px 0px 4px',
        paddingLeft: 57
    },
    searchIcon: {
        position: 'absolute',
        marginTop: 24,
        marginLeft: 21,
        color: '#7F91A2',
        zIndex: 1
    },
    rounded: {
        borderBottom: '1px solid lightgray'
    },
    PanelRoot: {
        boxShadow: 'none',
        '&:before': {
            display: 'none'
        }
    },
    maxWidth: {
        maxWidth: 1120
    },
    style1: {
        color: 'red !important',
        fontSize: "50px !important"
    }
});




class FAQS extends React.Component {

    constructor(props) {
        super();
        this.state = {
            panel: 'panel0',
            faqs: [
               
        {
            "question": "What is Islam?",
            "answer": "<div><p><span>Islam is a faith of pure monotheism that builds on the messages of previous prophets sent to humankind throughout history.</span><p/>Islam is a continuation of the same message preached by all of God’s prophets — ending with the final prophet, Muhammad ﷺ — calling people to believe and worship in the one, true God alone. It is the original religion of Adam, Abraham, Moses, and Jesus that clarifies the purpose of creation and guides us on how to live a Godly, righteous life.<br/></br>As the final message from God to humanity, Islam is a manifestation of the Divine covenant made before the creation of the world where every soul gathered to recognize God as their Lord. In the Islamic worldview, this knowledge is coded into our subconscious makeup. Through testifying one’s faith, we reaffirm our witness of God’s Lordship and commit to living out a life according to and in line with His will. The Qur’an, God’s final words revealed to Prophet Muhammad, and prophetic teachings (Sunnah) offer guidance on how to adhere to the message.</div>"
        },
        
        {
            "question": "What does Islam mean?",
            "answer": "The word ‘Islam’ is an Arabic term encompassing the meanings of submission, surrender, and peace."
        },
    
        {
            "question": "What do Muslims believe?",
            "answer": "<div><p><span>In Islam, faith is composed of six core articles of faith, commonly referred to as the pillars of faith.</span></p><p>They are:</p><li>Belief in God</li><li>Belief in angels</li><li>Belief in Divinely revealed books</li><li>Belief in the Messengers of God</li><li>Belief in the Day of Judgement</li><li>Belief in Divine Decree</li></div>"
        },
    
        {
            "question": "Who is Allah? ",
            "answer": "<div><p><span>Allah is simply the Arabic word for God.</span></p><br/></br>Say [O Prophet], “He is Allah—One. God, the eternal. He has never had offspring, nor was He born. And there is none comparable to Him.”<span>(Qur’an 112: 1-4).</span><br/>The word ‘Allah’ does not have a gender or a plural form, indicating God’s uniqueness from all creation and His absolute oneness. Allah is also the term for ‘God’ used by non-Muslim Arabic speakers such as Arab Christians.</br></br>Muslims believe God is exalted above everything else in the universe, unrestricted by time and space, and distinct in His attributes. He is All-Powerful and All-Wise, with full control over the universe, as it was created by His will. As taught in the Qur’an, Allah is the Lord of all the Worlds; humanity’s Creator, Nourisher, and Sustainer, whom all should worship and love.</br></br>The 99 Beautiful Names of God encapsulate the various divine attributes through which God has described Himself. Allah is not restricted to these names alone; rather, they are a means by which someone can begin to know Him. God, above all else in the Islamic worldview, is the Most Merciful and the Most Kind (these are the names most often repeated in the Qur’an and in daily prayers), the Most Loving, and the Source of all peace, reliance, and refuge. The gift of worship is from His bounty to keep mankind forever connected to Him.</br></br><span>“He is God: there is no god other than Him. It is He who knows what is hidden as well as what is in the open, He is the Lord of Mercy, the Giver of Mercy. He is God: there is no god other than Him, the Controller, the Holy One, Source of Peace, Granter of Security, Guardian over all, the Almighty, the Compeller, the Truly Great; God is far above anything they consider to be His partner. He is God: the Creator, the Originator, the Shaper. The best names belong to Him. Everything in the heavens and earth glorifies Him: He is the Almighty, the Wise.” [Quran, 59:22-24]</span></div>"
        },
    
        {
            "question": "What is the Qur’an? ",
            "answer": "<div><p><span>The Qur’an is the speech of God revealed to Prophet Muhammad ﷺ</span></p>through the Angel Gabriel (Jibril) over a period of 23 years.<br/></br>The Qur’an constitutes the final revealed message from God through the last prophet and messenger sent to the world.<br/></br>The Qur’an is both miraculously preserved and inimitable. In other words, what we know as the Qur’an today is the exact same text that was revealed to Prophet Muhammad ﷺ. The Qur’an is also miraculous in that it is impossible for human beings to imitate, contains no errors or contradictions, accurately foretells future events, describes matters of the natural world unknown to human beings at the time of revelation, and contains benefit for all human beings.</div>"
        },
    
        {
            "question": "Who is Prophet Muhammad?",
            "answer": "<div><p><span>Muhammad ﷺ, the son of Abdullah, was the final prophet and messenger of God. </span></p>He was born in 570 CE in Mecca, where he eventually received the final revealed book sent to humanity, the Qur’an, and began calling people to the religion of Islam. <br/></br>Despite facing many challenges and being met with rejection and persecution during his life and prophetic mission, he unfailingly exhibited beautiful character, rose above enmity and insult, and accomplished a stunning array of achievements. He is the most beloved of all creation to God, and is the greatest of not only all of God’s prophets and messengers, but the entirety of creation.<br/></br>Prophet Muhammad ﷺ is often described as the “founder of Islam,” but this is not exactly accurate. Islam did not begin with his prophetic mission. Instead, it is more accurate to say he was sent to confirm and restore the messages of previous prophets and scriptures in their original, uncorrupted forms. All of the messengers of God, from Adam to Jesus to Muhammad, conveyed the same fundamental message of monotheism and good works and are brothers in prophethood.</div>"
        },
    
        {
            "question": "What are the five pillars of Islam?",
            "answer": "<div><p><span>The five pillars of Islam are: the testimony of faith, prayer, zakat, fasting of Ramadan, and performing hajj.</span></p>Islam can be imagined as a building supported by five pillars. Each of these pillars are necessary for the building of Islam to stand. Without them, the structure collapses. These pillars are: Shahada: Testifying that there is no god but Allah (God), and that Muhammad ﷺ is the final Messenger of God Salat: Praying five daily prayers Zakat: Donating an obligatory amount of charity Sawm: Fasting in Ramadan Hajj: Making the pilgrimage to the Ka’aba<p><span>Everything else in Islam is built upon these five foundational pillars. </span></p></div>"
        },
    
        {
            "question": "What is the Islamic testimony of faith (shahada)?",
            "answer": "<div><p><span>The shahada is to believe in the message of Islam and declare that: There is no god but Allah (God), and Muhammad ﷺ is the Messenger of God.</span></p></br>This testimony of faith, known in Arabic as the shahada, encapsulates the religion of Islam. It must be affirmed in the heart and uttered by the tongue. <br/></br>The shahada is a declaration of monotheism (tawhid) stating that there is absolutely no deity except for the one, true, creator: God. He has no partners in divinity, no children, and none are worthy of worship except Him.<br/></br>It is also a statement of acceptance that Prophet Muhammad ﷺ is God’s final prophet and messenger.</div>"
        },
    
        {
            "question": "Why do Muslims pray daily?",
            "answer": "<div><p><span>Prayer (salah) forges and sustains an essential connection between a person and their Creator.</span></p></br>Muslims have been instructed by God to pray five times daily within prescribed times. The Qur’an informs us that the primary reason for our creation and existence is to worship God, and these required five daily prayers are, in essence, a foundational fulfillment of this existential purpose.</div>"
        },
    
        {
            "question": "What is zakat?",
            "answer": "<div><p><span>Zakat refers to an obligatory portion of wealth a Muslim must give annually to the poor and needy. </span></p></br>Islamic law details the various types of wealth that are zakat-eligible, how it is calculated, and the specific categories of people eligible to receive it.<br/></br>Zakat is frequently mentioned alongside prayer (salat) throughout the Qur’an and was a ubiquitous feature of all prophetic calls. Among the five pillars of Islam, zakat is unique in that, in addition to being an act of devotion to God, it plays an important social function. While things like prayer and fasting are, on their face, individual acts of ritual devotion, zakat directly benefits one’s community and, as an institution, wields immense economically and socially transformative power.</div>"
        }
    ]
            
        }
        
    }

    handleChange = (panel) => {
        this.setState({
            panel: panel
        })
    }

    componentDidMount() {
        this.props.GetAllFAQS();
    }

    onRemoveClick = () => {
        this.setState({
            panel: false
        })
    }


    
        
    
    

    


    render() {
        const { classes } = this.props;
        const { panel, faqs } = this.state;
        console.log('faqs', faqs);


        return (
            <Container classes={{ root: classes.maxWidth }}>
                <Grid container spacing={3}>

                    <Grid item xs={12} md={8} className={classes.donateBox}>
                        {/* <Grid container>
                            <Grid item xs={9} className={classes.searchBox}>

                                <SearchIcon className={classes.searchIcon} />

                                <InputBase
                                    id="outlined-basic"
                                    label="Search"
                                    placeholder="Type Keyword.."
                                    className={classes.searchField}
                                    inputProps={{ 'aria-label': 'naked' }}
                                />
                            </Grid>

                            <Grid item xs={3} >
                                <Button variant="outlined" size="medium" className={classes.searchButton}>
                                    Search
                            </Button>
                            </Grid>

                        </Grid> */}

                        {faqs && faqs.map((faq, index) => (

                            <ExpansionPanel classes={{ root: classes.PanelRoot, rounded: classes.rounded }} expanded={panel === `panel${index}`} >
                                <ExpansionPanelSummary
                                    expandIcon={panel === `panel${index}` ? <RemoveCircleIcon className={classes.iconColor} onClick={this.onRemoveClick} /> : <AddCircleIcon className={classes.iconColor} onClick={() => this.handleChange(`panel${index}`)} />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                >
                                    <Typography onClick={() => this.handleChange(`panel${index}`)} className={`${classes.question}  ${panel === `panel${index}` && classes.activeColor} `}>0{index + 1}. {faq.question} </Typography>
                                </ExpansionPanelSummary>

                                <ExpansionPanelDetails>
                                    <Typography className={classes.answer} dangerouslySetInnerHTML={{ __html: faq.answer }}>
                                        {/* {faq.answer} */}
                                    </Typography>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        ))}


                    </Grid>

                    <Grid item xs={12} md={4}  >

                        <Box className={classes.handContent}>
                            <img src={HandImg} alt="hand-png" />
                        </Box>
                        <Box className={classes.donateContent}>
                            <h4 className={classes.donateTitle}>ORDER FREE QURAN</h4>
                            <p className={classes.donate}>Order your free copy of Quran in the language and quantity you need</p>
                            <Button variant="outlined" size="medium" className={classes.donateButton} component={RouterLink} to="/order" >
                                ORDER NOW
                        </Button>
                        </Box>

                        <Box className={classes.handContent2}>
                            <img src={HandImg} alt="hand-png" />
                        </Box>
                        <Box className={classes.donateContent2}>
                            <h4 className={classes.donateTitle}>DONATE US</h4>
                            <p className={classes.donate}>Be a part of our awesome quest. Be part of the reward by sponsoring Al-Quran</p>
                            <Link
                                target="_blank"
                                underline="none"
                                rel="noopener noreferrer"
                                href={process.env.REACT_APP_DONATE_URL}
                            >
                                <Button variant="outlined" size="medium" className={classes.donateButton2}>
                                    DONATE US
                        </Button>
                            </Link>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        );
    }
}

FAQS.propTypes = {
    GetAllFAQS: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    home: state.home
});


export default withStyles(styles)(connect(mapStateToProps, { GetAllFAQS })(FAQS));